import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { LogOut, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

const navLinks = [
  { label: "About us", path: "/about" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Events", path: "/events" },
  { label: "Blog", path: "/blog" },
  { label: "Community", path: "/community" },
  { label: "The waste crisis", path: "/waste-crisis" },
  { label: "Contact us", path: "/contact" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-black/95 backdrop-blur-xl">
      <div className="container relative mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src="/images/hintsly-logo-transparent.webp"
            alt="Hintsly logo"
            width={72}
            height={72}
            className="h-14 w-14 object-contain"
            loading="eager"
          />
        </Link>
        <span className="absolute left-1/2 -translate-x-1/2 text-[10px] font-semibold uppercase tracking-[0.24em] text-secondary hidden md:inline-flex">Premium gifting</span>

        <div className="flex items-center gap-2 shrink-0">
          {user ? (
            <Button variant="ghost" size="sm" onClick={handleSignOut} className="hidden sm:inline-flex">
              <LogOut className="h-4 w-4 mr-1" /> Sign out
            </Button>
          ) : (
            <Button variant="default" size="sm" asChild className="hidden sm:inline-flex">
              <Link to="/auth">Sign in</Link>
            </Button>
          )}

          <div className="relative">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>

            {menuOpen && (
              <nav
                className="absolute right-0 top-full mt-2 w-56 rounded-xl border border-border bg-black shadow-lg py-2 z-50"
                aria-label="Main navigation"
              >
                {navLinks.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setMenuOpen(false)}
                    className="block px-4 py-2.5 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
                  >
                    {item.label}
                  </Link>
                ))}

                <div className="sm:hidden border-t border-border mt-1 pt-1">
                  {user ? (
                    <button
                      onClick={() => { handleSignOut(); setMenuOpen(false); }}
                      className="block w-full text-left px-4 py-2.5 text-sm font-medium text-destructive hover:bg-destructive/10 transition-colors"
                    >
                      Sign out
                    </button>
                  ) : (
                    <Link
                      to="/auth"
                      onClick={() => setMenuOpen(false)}
                      className="block px-4 py-2.5 text-sm font-medium text-primary hover:bg-muted transition-colors"
                    >
                      Sign in
                    </Link>
                  )}
                </div>
              </nav>
            )}
          </div>
        </div>
      </div>
      <div className="h-[3px] w-full bg-destructive" />
    </header>
  );
};

export { Header };
export default Header;
